// BookTickets/stages/PaymentProcess/components/MbWayForm.tsx
'use client'

import cn from 'classnames'
import { useMemo, useState } from 'react'
import { useTranslations } from 'next-intl'

import shared from '@booking/index.module.scss'
import styles from './index.module.scss'

import { useMbWayPayment } from './hooks/useMbWayPayment'

type MbWayFormProps = {
  hasFired: boolean
  onFire?: () => Promise<void> | void
}

export default function MbWayForm({ hasFired, onFire }: MbWayFormProps) {
  const t = useTranslations('booking')
  const [phone, setPhone] = useState('')

  const { waiting, error, start } = useMbWayPayment({
    hasFired,
    onFire,
  })

  const canSubmit = useMemo(() => !waiting && phone.trim().length > 0, [phone, waiting])

  return (
    <form className={cn(styles.form)} onSubmit={(e) => e.preventDefault()}>
      <div>
        <label htmlFor="mbway-phone" className="block text-gray-700 text-sm font-bold mb-2">
          {t('ticket.payment.mbway.phoneNumber')}
        </label>

        <input
          id="mbway-phone"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          disabled={waiting}
          placeholder={t('ticket.payment.mbway.phoneNumber')}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className={cn(shared.input, 'mb-3')}
        />

        {error ? <div className={cn(styles.inputError)}>{error}</div> : null}
      </div>

      <button
        type="button"
        className={cn(shared.button, styles.button)}
        onClick={() => start(phone)}
        disabled={!canSubmit}
      >
        {waiting ? (
          <span className={cn(styles.waiting)}>{t('ticket.payment.mbway.awaiting')}</span>
        ) : (
          t('ticket.payment.mbway.continue')
        )}
      </button>
    </form>
  )
}
